import { Box, Chip, Grid, Typography } from '@mui/material'
import { useState } from 'react'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import Stepper from '../../atoms/Stepper/Stepper'
import Style from '../../molecules/VenderModal/VendorModal.module.scss'
import InputCustom from '../../atoms/input/InputCustom'
import { BUSINESS_PROFILE_TOTAL_STEPS } from '../../../util/constants'
import { toastHelper } from '../../../util/toastHelper'
const defaultCover = '/images/service-modal-img.png'

function Services({ step, setStep, formData, setFormData, onUpdateProfile, saving = false }) {
	const [newService, setNewService] = useState('')

	const services = formData.services || []

	const handleAdd = () => {
		const trimmed = newService.trim()
		if (!trimmed) return
		if (services.includes(trimmed)) {
			setNewService('')
			return
		}

		const updatedServices = [...services, trimmed]
		setFormData({
			...formData,
			services: updatedServices,
		})
		setNewService('')
	}

	const handleDelete = (deletedService) => {
		const updatedServices = services.filter(
			(service) => service !== deletedService
		)
		setFormData({
			...formData,
			services: updatedServices,
		})
	}

	const handleChange = (e) => {
		setNewService(e.target.value)
	}

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault()
			handleAdd()
		}
	}
	return (
		<>
			<Grid size={{ xs: 12, sm: 6 }}>
				<div className={Style.imageContainer}>
					<img src={defaultCover} alt="signup-img.jpg" />
				</div>
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }} className={Style.formContainer}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'space-between',
						minHeight: '80%',
						height: '100%',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
						className={Style.titleContainer}
					>
						<Typography
							variant="h3"
							gutterBottom
							className={Style.title}
						>
							Services
						</Typography>
						<Typography
							color="#7ca6bd"
							variant="h6"
							className={Style.modalSemiTitle}
						>
							Select a few services to start. You can always add
							more on your profile.
						</Typography>
					</Box>
					<Box
						sx={{
							width: '100%',
							maxWidth: '350px',
							margin: '0 auto',
						}}
					>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								gap: '1rem',
							}}
						>
							<InputCustom
								value={newService}
								onChange={handleChange}
								onKeyDown={handleKeyDown}
								placeholder="Add Service"
							/>
							<ButtonCustom
								variant="outlined"
								size="lg"
								onClick={handleAdd}
							>
								Add
							</ButtonCustom>
						</Box>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'column',
								gap: '8px',
								mt: '1rem',
								maxHeight: '200px',
								overflowY: 'auto',
								pr: '5px',
							}}
						>
							{services.map((service) => (
								<ButtonCustom
									key={service}
									variant="pilled"
									size="md"
									onClick={() => handleDelete(service)}
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
										gap: '8px',
									}}
								>
									{service}
									<img
										src="/images/modal-close-icon.svg"
										alt="close"
										style={{
											width: '14px',
											height: '14px',
										}}
									/>
								</ButtonCustom>
							))}
						</Box>
					</Box>
					<Box
						className={Style.buttonContainer}
						sx={{ justifyContent: 'space-between' }}
					>
						<ButtonCustom
							onClick={() => setStep((step) => step - 1)}
							className="backButton"
						>
							Previous
						</ButtonCustom>
						<ButtonCustom
							disabled={saving}
							onClick={() => {
								if (services.length > 0) {
									onUpdateProfile(() =>
										setStep((step) => step + 1)
									)
								} else {
									toastHelper(
										'Please add at least one service',
										'error'
									)
								}
							}}
						>
							{saving ? 'Saving…' : 'Next'}
						</ButtonCustom>
					</Box>
					<Box>
						<Stepper
							totalSteps={BUSINESS_PROFILE_TOTAL_STEPS}
							subSteps={1}
							activeStep={step}
						/>
					</Box>
				</Box>
			</Grid>
		</>
	)
}

export default Services
